
import { defineComponent } from "vue";
import { HSV2HEX } from "../../utils/color";

export default defineComponent({
  props: {
    h: { type: Number, required: true },
    s: { type: Number, required: true },
    v: { type: Number, required: true },
  },
  emits: [
    "update:s", "update:v",
  ],
  data: () => ({
    moveHandler: null as ((e: PointerEvent) => void) | null,
    upHandler: null as ((e?: PointerEvent) => void) | null,
  }),
  computed: {
    baseColor(): string {
      return HSV2HEX({ h: this.h, s: 100, v: 100 });
    },
  },
  beforeUnmount() {
    if (this.upHandler) {
      this.upHandler();
    }
  },
  methods: {
    startDrag(evt: PointerEvent): void {
      if (this.moveHandler) return;
      const rect = (this.$refs.container as HTMLDivElement).getBoundingClientRect();
      this.moveHandler = (e: PointerEvent) => {
        const white = (e.clientX - rect.left) / rect.width;
        const black = 1 - (e.clientY - rect.top) / rect.height;
        this.$emit("update:s", 100 * Math.min(1, Math.max(0, white)));
        this.$emit("update:v", 100 * Math.min(1, Math.max(0, black)));
        e.preventDefault();
      };
      this.upHandler = (e?: PointerEvent) => {
        if (this.moveHandler) {
          document.removeEventListener("pointermove", this.moveHandler);
          this.moveHandler = null;
        }
        if (this.upHandler) {
          document.removeEventListener("pointerup", this.upHandler);
          document.removeEventListener("pointerleave", this.upHandler);
          this.upHandler = null;
        }
        if (e) {
          e.preventDefault();
        }
      };
      document.addEventListener("pointermove", this.moveHandler);
      document.addEventListener("pointerup", this.upHandler);
      document.addEventListener("pointerleave", this.upHandler);
      this.moveHandler(evt);
    },
  },
});
